import React from 'react';
import { ShieldCheck, Lock, CreditCard } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function Hero() {
  return <section className="bg-brand-dark text-white pt-6 pb-2 px-3 md:pt-12 md:pb-4" data-id="element-169">
      <div className="max-w-xl mx-auto text-center" data-id="element-170">
        <div className="animate-fadeInUp" data-id="element-171">
          {/* Small badge */}
          <div className="inline-block bg-amber-500/20 text-brand-yellow px-4 py-1.5 rounded-full text-xs font-bold mb-4 border border-amber-500/30 tracking-wide" data-id="element-172">
            👩‍⚕️ SISTEMA COMPLETO PARA ENFERMERÍA CLÍNICA
          </div>

          {/* Main headline - larger and bolder */}
          <h1 className="text-[2rem] md:text-5xl lg:text-6xl font-extrabold leading-[1.1] mb-3 px-0" data-id="element-173">
            👉 Todas tus decisiones en Enfermería...{' '}
            <span className="bg-gradient-to-r from-amber-400 to-orange-500 bg-clip-text text-transparent" data-id="element-174">
              resueltas
            </span>
          </h1>

          {/* Product image - optimized for LCP */}
          <div className="relative mb-6 max-w-lg mx-auto" data-id="element-175">
            <img src="https://cdn.magicpatterns.com/uploads/61dVqujWzfz7p7uZb7G8ap/MOCKUP_FINAL_600x.png" alt="Mega Pack Mente Clínica en Acción" fetchPriority="high" loading="eager" width="600" height="450" className="w-full h-auto drop-shadow-[0_20px_50px_rgba(0,0,0,0.5)] hover:scale-[1.02] transition-transform duration-500" data-id="element-176" />
          </div>

          {/* Yellow highlight text */}
          <p className="text-brand-yellow text-base md:text-lg font-medium italic mb-3 max-w-sm mx-auto leading-snug" data-id="element-177">
            Listo para usar. Sin sobrepensar. Sin bloquearte. Sin perder tiempo
            dudando…
          </p>

          {/* Full-width CTA */}
          <CTAButton text="👉 QUIERO ACTUAR CON SEGURIDAD EN GUARDIA" className="w-auto mx-auto mb-5 py-3 px-6 text-sm md:text-base font-black rounded-xl" data-id="element-178" />

          {/* Trust badges - compact row */}
          <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1.5 text-[11px] md:text-xs text-gray-500" data-id="element-179">
            <div className="flex items-center gap-1" data-id="element-180">
              <ShieldCheck size={14} className="text-brand-yellow" data-id="element-181" />
              <span data-id="element-182">Garantía 7 días sin preguntas</span>
            </div>
            <div className="flex items-center gap-1" data-id="element-183">
              <Lock size={14} className="text-brand-yellow" data-id="element-184" />
              <span data-id="element-185">Pago 100% seguro</span>
            </div>
            <div className="flex items-center gap-1" data-id="element-186">
              <CreditCard size={14} className="text-brand-yellow" data-id="element-187" />
              <span data-id="element-188">Pagás en pesos argentinos</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}